<template>
  <div class="hidden-sm-and-down">
    <!-- Ads / Carousel -->
    <v-col cols="12">
      <v-card max-width="300" class="premium-card text-center overflow-hidden">
        <v-carousel hide-delimiters height="200" cycle interval="4000" show-arrows-on-hover>
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            :src="item.src"
            reverse-transition="fade-transition"
            transition="fade-transition"
          ></v-carousel-item>
        </v-carousel>
      </v-card>
    </v-col>

    <!-- Trending Topics -->
    <v-col cols="12" class="py-1">
      <v-card class="premium-card" max-width="300">
        <v-card-text class="pa-3">
          <p class="section-title mb-3">🔥 Trending Topics</p>
          <div v-for="(topic, idx) in trending" :key="idx" class="mb-2">
            <v-chip
              small
              :color="topic.color"
              dark
              class="mr-1 mb-1"
              style="font-size: 11px"
            >{{ topic.tag }}</v-chip>
            <span style="font-size: 12px; color: #555">{{ topic.text }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Notifications -->
    <v-col cols="12" md="12" class="py-1">
      <v-card class="premium-card" max-width="300">
        <v-card-text class="pa-3">
          <p class="section-title mb-2">Recent Activity</p>
          <v-list class="pa-0">
            <template v-for="(nots, idx) in notification">
              <v-list-item class="pa-1 rounded-lg" :key="'notif-' + idx" style="min-height: 60px">
                <v-list-item-avatar size="38">
                  <v-avatar size="38">
                    <img :src="nots.image" alt="Profile picture" />
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <span style="font-size: 13px; font-weight: 600">{{ nots.name }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <p style="font-size: 11px" class="text-wrap mb-0 grey--text text--darken-1">
                      {{ nots.content }}
                    </p>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span style="font-size: 10px" class="grey--text">
                      <v-icon x-small color="grey" class="mr-1">mdi-clock-outline</v-icon>
                      {{ nots.date }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="'div-' + idx" v-if="idx < notification.length - 1" class="my-1"></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      { src: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=400&h=200&fit=crop" },
      { src: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=400&h=200&fit=crop" },
    ],
    trending: [
      { tag: "JAMB", color: "#f69227", text: "2026 UTME preparation tips" },
      { tag: "Physics", color: "#2089d6", text: "Newton's Laws explained" },
      { tag: "CS", color: "#43a047", text: "Introduction to algorithms" },
      { tag: "Math", color: "#cd67f7", text: "Calculus problem solving" },
    ],
    notification: [
      {
        name: "Amina Yusuf",
        content: "Applauded your chemistry lecture post",
        date: "2 hours ago",
        image: "https://randomuser.me/api/portraits/women/33.jpg",
      },
      {
        name: "Ibrahim Sani",
        content: "Started following you",
        date: "5 hours ago",
        image: "https://randomuser.me/api/portraits/men/67.jpg",
      },
      {
        name: "Fatima Bello",
        content: "Shared a quiz: Physics Motion & Forces",
        date: "1 day ago",
        image: "https://randomuser.me/api/portraits/women/45.jpg",
      },
      {
        name: "Adam Garba",
        content: "Commented on your discussion post",
        date: "2 days ago",
        image: "https://randomuser.me/api/portraits/men/29.jpg",
      },
    ],
  }),
};
</script>
